export default {
    //COIN
    getCoin: 'getCoins',
    fetchCoins: 'fetchCoins',

    //AUTH
    logIn:'logIn',
    setAuth: 'setAuth',
    setExpired : 'setExpired',
    getExpired : 'getExpired',
    logOut: 'logOut',
    getToken: 'getToken',
    getUser: 'getUser',
    getRefreshToken: 'getRefreshToken',
    refreshToken:'refreshToken',
    setUsuario: 'setUsuario',
    getUsuario: 'getUsuario',
    buscarUsuario: 'buscarUsuario',
    fethcUser:'fetchUser',
    getPermisos: 'getPermisos',
    getIntegrado: 'getIntegrado',
    getDependencia: 'getDependencia',
    cambioIdDependencia: 'cambioIdDependencia',
    idDependencia: 'idDependencia',
    setDatosSesion:'setDatosSesion',
    setSistemaPrincipal:'setSistemaPrincipal',
    getSistemaPrincipal:'getSistemaPrincipal',

    //CATALOGOS
    getCatalogos:'getCatalogos',
    fetchCatalogos: 'fetchCatalogos',
    setPrincipal : 'setPrincipal',
    getPermisosPrincipal : 'getPermisosPrincipal',
    // getCatalogoGenerico: 'getCatalogoGenerico',
    fetchCatalogoGenerico: 'fetchCatalogoGenerico',

    //ACTIVACION DE CUENTAS
    putVerificar: 'putVerificar',
    // auth
    client_credentials: 'client_credentials',
    changePassword: 'changePassword',  

}
